import request from '@/utils/request'

  
export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/orderCoach/Create',
    method: 'post',
    data,
  })
}

export function fetchList(data) {
  return request({
    url: '/orderCoach/List',
    method: 'post',
    data,
  })
}


export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/orderCoach/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/orderCoach/Delete',
    method: 'delete',
    data,
  })
}
  

 

